import {
  Button,
  Div,
  H3,
  Modal,
  P,
  useMerchantContactSupport,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const NoLocationsWithVDrive = ({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  // The merchant app's support chat; admin provides none, so no button there.
  const contactSupport = useMerchantContactSupport();

  return (
    <>
      <Modal
        isOpen={isOpen}
        closeModal={() => setIsOpen(false)}
        logo={false}
        vDriveLogo
        exitButton={false}
      >
        <H3 $m="10px" $center>
          Manual Delivery
        </H3>
        <P $mb="40" $center>
          Your vDrive service has to be enabled in order to use it. <br /> For
          more info reach out to support team.
        </P>

        <Div $flex $column $gap="12px">
          {contactSupport && (
            <Button
              $w="100%"
              $selected
              onClick={() => {
                setIsOpen(false);
                contactSupport();
              }}
            >
              Contact Support
            </Button>
          )}
          <Button
            $w="100%"
            onClick={() => setIsOpen(false)}
            $selected
            $gray={!!contactSupport}
          >
            Okay
          </Button>
        </Div>
      </Modal>
    </>
  );
};
